<!--对讲单独页面 -->
<template>
  <div class="intercom">
    <Walkie :soloPage="soloPage"></Walkie>
    <!-- 语音播放节点 -->
    <div id="walkieDiv"></div>
  </div>
</template>
<script>
import Walkie from '@/components/walkie/Walkie'
import { setSession, nowDateTime } from '@/api/common'
import { getLogin } from '@/api/login'
import { createSocket } from '@/api/websocket'
import { creatGK3Socket } from '@/common/websocket/index'
import { mapGetters } from 'vuex'
import { loginWalkie } from '@/common/rtc/mediasoup/mediasoup-walkie'
import { getRealVideoUrl } from '@/api/iam-manage/config'
import { walkieRegist } from '@/common/rtc/srs/video-walkie'
import { _getUserSig } from '@/common/websocket/trtc-walkie'

import { loginStorage } from '@/common/loginStorage'
import md5 from 'js-md5'
export default {
  data() {
    return {
      soloPage: true,
      userName: '',
      password: '',
      timestamp: '',
      userId: '',
      mediaServe: '',
    }
  },
  components: { Walkie },
  mounted() {
    this.username = this.getQueryVariable('appKey')
    let secretKey = this.getQueryVariable('secretKey')
    this.timestamp = nowDateTime()
    let passKey = secretKey + '.' + this.username + '.' + this.timestamp + '.' + secretKey
    this.password = md5(passKey)
    this.login()
  },
  methods: {
    getQueryVariable(name) {
      try {
        var url = window.location.href
        if (url.indexOf('?') === -1) {
          return ''
        }
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = url.split('?')[1].match(reg)
        if (r != null) {
          return r[2]
        }
        return ''
      } catch (e) {
        return ''
      }
    },
    // 请求ws 连接地址
    getCloudRoomUrl() {
      getRealVideoUrl().then(url => {
        let urlData = url.split('|')
        setSession('appMvcp', urlData[0])
        setSession('appUrl', urlData[1])
      })
      if (this.rtcType === 'srs') {
        //  连接注册新媒体平台 服务
        walkieRegist()
      } else if (this.rtcType === 'mediasoup') {
        loginWalkie()
      } else if (this.rtcType === 'trtc') {
        _getUserSig()
      }
    },
    // 请求登录接口、登录成功后连接websocket服务
    login() {
      let params = {
        data: {
          username: this.username,
          password: this.password,
          grant_type: 'password',
          auth_type: 'ak_sk',
          timestamp: this.timestamp,
        },
      }
      getLogin(params).then(val => {
        let state = val.state
        let res = val
        if (state === 0) {
          if (!this.isCloud) {
            this.getCloudRoomUrl()
          } else if (this.rtcType === 'trtc') {
            _getUserSig()
          }
          this.$store.dispatch('alterName', res.username)
          // 参数储存
          loginStorage(res)

          createSocket()
          creatGK3Socket()

          if (localStorage.getItem('theme') === null) {
            localStorage.setItem('theme', 'default')
          }

          // 打开对讲
          setTimeout(() => {
            this.$AlertWalkie({
              show: true,
              content: 'solo',
            })
          }, 1000)
        } else {
          console.log('登录失败')
        }
      })
    },
  },
  computed: {
    ...mapGetters(['isCloud', 'rtcType']),
  },

  created() {
    localStorage.setItem('theme', 'default')
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.intercom
  height: 100%;
  background: #333
.pop
  width 100%!important
  // min-width 500px;/*no*/
  border-radius 8px
  // position fixed
  // top 50%
  // left 50%
  // transform translate(-50%, -50%)
  // z-index 2080
</style>
